import { Alert } from 'aui';
import type { ReactNode } from 'react';
import { Component } from 'react';

interface IProps {
  children: ReactNode;
}

interface IState {
  error?: Error;
}

export class ErrorBoundary extends Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  public componentDidCatch(error: Error, info: object) {
    this.setState({ error });
  }

  public render() {
    const { error } = this.state;
    if (error !== undefined) {
      return (
        <div className="p-5">
          <Alert
            message="An error occurred"
            description={`${error.name}: ${error.message}`}
            type="error"
          />
        </div>
      );
    }
    return this.props.children;
  }
}
